"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAsyncAction = exports.AsyncActionTypes = void 0;

var _reduxAct = require("redux-act");

var AsyncActionTypes;
exports.AsyncActionTypes = AsyncActionTypes;

(function (AsyncActionTypes) {
  AsyncActionTypes["Pending"] = "REQUEST";
  AsyncActionTypes["Fulfilled"] = "FULFILLED";
  AsyncActionTypes["Rejected"] = "REJECTED";
  AsyncActionTypes["Cancel"] = "CANCEL";
})(AsyncActionTypes || (exports.AsyncActionTypes = AsyncActionTypes = {}));

var createAsyncAction = function createAsyncAction(prefix) {
  var pending = (0, _reduxAct.createAction)("".concat(prefix, "/").concat(AsyncActionTypes.Pending));
  var fulfilled = (0, _reduxAct.createAction)("".concat(prefix, "/").concat(AsyncActionTypes.Fulfilled));
  var rejected = (0, _reduxAct.createAction)("".concat(prefix, "/").concat(AsyncActionTypes.Rejected));
  var canceled = (0, _reduxAct.createAction)("".concat(prefix, "/").concat(AsyncActionTypes.Cancel));
  return Object.assign(pending, {
    pending: pending,
    fulfilled: fulfilled,
    rejected: rejected,
    canceled: canceled
  });
};

exports.createAsyncAction = createAsyncAction;